(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-landing-bonuses"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('nlb-carousel')) return;

    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));

    // Theme Editor only: the editor re-renders the section after every setting change, which would jump back to
    // slide 1. The slide on show is kept in memory (per section id, nothing is stored anywhere) so the slide being
    // edited stays on screen. Storefront visitors never use this: they always start on the Warranty.
    const editorSlides = new Map();

    class NlbCarousel extends HTMLElement {
      connectedCallback() {
        if (this._ac) return;

        // The script can run before the markup below this element has been parsed.
        if (document.readyState === 'loading' && !this.querySelector('[data-nlb-rail]')) {
          this._onReady = () => this._init();
          document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
          return;
        }

        this._init();
      }

      disconnectedCallback() {
        if (this._onReady) {
          document.removeEventListener('DOMContentLoaded', this._onReady);
          this._onReady = null;
        }

        this._destroy();
      }

      _init() {
        if (this._ac || !this.isConnected) return;

        this.rail = this.querySelector('[data-nlb-rail]');
        if (!this.rail) return;

        this._sid = this.getAttribute('data-section-id') || this.id;
        this._design = this.hasAttribute('data-nlb-design');

        this.prevBtn = this.querySelector('[data-nlb-prev]');
        this.nextBtn = this.querySelector('[data-nlb-next]');
        this.counter = this.querySelector('[data-nlb-counter]');
        this.progress = this.querySelector('[data-nlb-progress]');
        this.live = this.querySelector('[data-nlb-live]');

        this._ac = new AbortController();
        const { signal } = this._ac;

        this._idx = 0;
        this._target = 0;
        this._n = 0;
        this._h = 0;
        this._segCount = this.progress ? this.progress.children.length : 0;
        this._navActive = false;
        this._silent = true; // nothing is announced for the first state
        this._raf = 0;
        this._settleTimer = 0;

        this.rail.addEventListener('scroll', () => this._onScroll(), { passive: true, signal });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._step(-1), { signal });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._step(1), { signal });
        this.addEventListener('keydown', (event) => this._onKey(event), { signal });

        // Keep the current slide aligned, and the row the right height, when the column or the slide content changes.
        if ('ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(() => {
            // Work happens in the next frame, outside the observer callback, so changing the row height here can
            // never re-trigger it (no "ResizeObserver loop" warning).
            cancelAnimationFrame(this._roFrame);
            this._roFrame = requestAnimationFrame(() => this._onResize());
          });
          this._resizeObserver.observe(this.rail);
          this._observed = new Set();
        }

        // Coming back to the page from the back/forward cache: start again on the first slide.
        window.addEventListener('pageshow', (event) => { if (event.persisted) this._reset(); }, { signal });

        // Theme Editor: let go when this section (and only this one) is unloaded.
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail && event.detail.sectionId === this._sid) this._destroy();
        }, { signal });

        this._reset();
        if (this._design) {
          const kept = editorSlides.get(this._sid);
          if (kept > 0) this.go(kept, { instant: true, silent: true });
        }
        this.setAttribute('data-nlb-ready', '');
      }

      _destroy() {
        if (!this._ac) return;
        if (this._design && this._sid) editorSlides.set(this._sid, this._idx || 0);
        this._ac.abort();
        this._ac = null;
        if (this._resizeObserver) this._resizeObserver.disconnect();
        cancelAnimationFrame(this._raf);
        cancelAnimationFrame(this._roFrame);
        clearTimeout(this._settleTimer);
        this._resizeObserver = null;
        this._observed = null;
        if (this.rail) this.rail.style.height = '';
      }

      /* The slides that really rendered, in the order the customer sees them (Warranty, Starter Pack, Sauna Drink). */
      _slides() {
        return Array.from(this.rail.querySelectorAll(':scope > [data-nlb-slide]')).filter(
          (el) => !el.hidden && el.getClientRects().length > 0
        );
      }

      _setDisabled(button, disabled) {
        if (button) button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }

      _buildSegments(n) {
        if (!this.progress || this._segCount === n) return;
        while (this.progress.children.length > n) this.progress.lastElementChild.remove();
        while (this.progress.children.length < n) {
          const seg = document.createElement('span');
          seg.className = 'nlb__seg';
          this.progress.appendChild(seg);
        }
        this._segCount = n;
      }

      /* Row height = height of the slide on show. Eased when the slide changes, instant on first fit and resize. */
      _fit(idx, instant) {
        const slide = this._list && this._list[idx];
        if (!slide) return;

        const height = Math.ceil(slide.getBoundingClientRect().height);
        if (!height || height === this._h) return;

        const rail = this.rail;
        if (instant || reduceMotion() || !this.hasAttribute('data-nlb-ready')) {
          rail.style.transition = 'none';
          rail.style.height = `${height}px`;
          void rail.offsetHeight;
          rail.style.transition = '';
        } else {
          rail.style.height = `${height}px`;
        }
        this._h = height;
      }

      /* Reads the slides, labels them, and paints the counter, segments and arrows. Returns the current index. */
      _update(instant) {
        const slides = this._slides();
        const n = slides.length;
        this._list = slides;
        this._n = n;

        this.toggleAttribute('data-nlb-single', n < 2);
        this._buildSegments(n);

        slides.forEach((slide, i) => slide.setAttribute('aria-label', `${i + 1} of ${n}`));

        if (this._resizeObserver) {
          slides.forEach((slide) => {
            if (!this._observed.has(slide)) {
              this._observed.add(slide);
              this._resizeObserver.observe(slide);
            }
          });
        }

        const width = this.rail.clientWidth || 1;
        const idx = n ? clamp(Math.round(this.rail.scrollLeft / width), 0, n - 1) : 0;
        this._paint(idx, n);
        this._fit(idx, instant);
        return idx;
      }

      _paint(idx, n) {
        if (this.progress) {
          Array.from(this.progress.children).forEach((seg, i) => seg.classList.toggle('is-active', i === idx));
        }
        if (this.counter) this.counter.textContent = `${idx + 1} / ${n}`;
        this._setDisabled(this.prevBtn, idx <= 0);
        this._setDisabled(this.nextBtn, idx >= n - 1);
      }

      _schedule(instant) {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = 0;
          const idx = this._update(instant === true);
          if (idx !== this._idx) {
            this._idx = idx;
            this._pending = true;
          }
        });
      }

      _onScroll() {
        this._schedule();
        this._armSettle(140);
      }

      _armSettle(ms) {
        clearTimeout(this._settleTimer);
        this._settleTimer = setTimeout(() => this._settled(), ms);
      }

      /* The scroll has stopped: say the new slide once (not once per slide passed on a fast swipe). */
      _settled() {
        this._navActive = false;
        const idx = this._update();
        this._target = idx;
        if (idx !== this._idx) {
          this._idx = idx;
          this._pending = true;
        }
        if (this._design) editorSlides.set(this._sid, idx);
        if (this._pending && !this._silent) this._announce(idx);
        this._pending = false;
        this._silent = false;
      }

      _announce(idx) {
        if (!this.live) return;
        const slides = this._slides();
        const slide = slides[idx];
        const title = slide ? slide.querySelector('[data-nlb-title]') : null;
        const label = title ? `: ${title.textContent.trim()}` : '';
        this.live.textContent = `Bonus ${idx + 1} of ${slides.length}${label}`;
      }

      _onResize() {
        if (this._navActive) return;
        const width = this.rail.clientWidth;
        const idx = clamp(this._idx, 0, Math.max(this._n - 1, 0));
        if (width && Math.abs(this.rail.scrollLeft - idx * width) > 1) {
          this.rail.scrollTo({ left: idx * width, behavior: 'auto' });
        }
        this._h = 0;
        this._update(true);
      }

      _reset() {
        this._silent = true;
        this._navActive = false;
        this._idx = 0;
        this._target = 0;
        this._h = 0;
        this.rail.scrollTo({ left: 0, behavior: 'auto' });
        this._update(true);
        if (this.live) this.live.textContent = '';
        this._armSettle(80); // clears the "silent" state even when the rail did not have to move
      }

      go(index, options = {}) {
        const n = this._n || this._slides().length;
        if (!n) return;

        const i = clamp(index, 0, n - 1);
        this._target = i;
        this._navActive = true;
        if (options.silent) this._silent = true;

        const behavior = options.instant || reduceMotion() ? 'auto' : 'smooth';
        this.rail.scrollTo({ left: i * this.rail.clientWidth, behavior });

        // If the position does not change there is no scroll event, so settle on a timer as well.
        this._armSettle(behavior === 'smooth' ? 500 : 60);
      }

      /* Repeated clicks keep moving from where the last click was heading, not from where the slide is mid-glide. */
      _step(direction) {
        const base = this._navActive ? this._target : this._idx;
        this._silent = false;
        this.go(base + direction);
      }

      _onKey(event) {
        if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (getComputedStyle(this).direction === 'rtl') return;

        let handled = true;
        if (event.key === 'ArrowLeft') this._step(-1);
        else if (event.key === 'ArrowRight') this._step(1);
        else if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this._n - 1);
        else handled = false;

        if (handled) event.preventDefault();
      }
    }

    customElements.define('nlb-carousel', NlbCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
